"use client";

import { animated, useChain, useSpring, useSpringRef } from "@react-spring/web";

const score2Angle: Record<number, number> = {
  0: -88,
  1: -75,
  2: -35,
  3: 0,
  4: 35,
  5: 75,
};

export const Needle = ({ score }: { score: number }) => {
  const rotateRef = useSpringRef();
  const opacityRef = useSpringRef();

  const { rotate } = useSpring({
    from: { rotate: 0 },
    to: { rotate: score2Angle[score] },
    ref: rotateRef,
  });

  const { opacity } = useSpring({
    opacity: 1,
    from: { opacity: 0 },
    delay: 250,
    ref: opacityRef,
  });

  useChain([opacityRef, rotateRef]);

  return (
    <animated.div
      className="absolute inset-x-0 top-[40%] mx-auto flex h-[90px] w-8 flex-col items-center"
      style={{ opacity }}
    >
      {/* Needle */}
      <animated.div
        className="h-0 w-0 origin-bottom border-b-[90px] border-l-[6px] border-r-[6px] border-b-black border-l-transparent border-r-transparent"
        style={{ rotate }}
      />
      {/* Dot */}
      <div className="absolute -bottom-4 aspect-1 w-full origin-bottom rounded-full border-[6px] border-white bg-black" />
    </animated.div>
  );
};
